/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCallRecOpenItem.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/call-rec-open-item";

export class AutogenModelCallRecOpenItem<RowType extends ModelRow> extends Endpoint<RowType, RowCallRecOpenItemFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCallRecOpenItem extends ModelRow<RowCallRecOpenItemFields> {
	constructor(values?: Partial<RowCallRecOpenItemFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCallRecOpenItemFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	bill_date: Date;
	bill_due_days: number;
	call_record_id: string;
	comments: string;
	company_id: string;
	consignee_refno: string;
	customer_id: string;
	days_past_due: number;
	entered_date: Date;
	id: string;
	image: string;
	invoice_no: number;
	invoice_no_string: string;
	no_auto_collect: string;
	open_item_id: string;
	order_id: string;
	record_type: string;
	reference_number: string;
	source: string;
	summary_billing: string;
}

